import { HttpEvent, HttpRequest, HttpHandler, HttpInterceptor } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BaseParamsService } from '@app/core/base-params.service';
import { Observable } from 'rxjs';

const LOCALE_HEADER = 'x-locale';

@Injectable()
export class LocaleInterceptor implements HttpInterceptor {
  private readonly baseParamsService = inject(BaseParamsService);

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const language = this.baseParamsService.language;

    if (!req.headers.has(LOCALE_HEADER) && language) {
      req = req.clone({
        headers: req.headers.set(LOCALE_HEADER, language),
      });
    }

    return next.handle(req);
  }
}
